import React from 'react';
import { useTestDataBanner } from '../contexts/TestDataBannerContext';
import { TEST_DATA_MODES } from '../services/rosterFixtures';

/**
 * GlobalTestDataBanner - the always-present test-data strip at the very top of
 * the app (above the navbar). Its primary control is the season-phase selector
 * (pre-draft / mid-season / after-season) that drives which sample data shows.
 * Pages may still supply a contextual note via the TestDataBannerContext.
 */
function GlobalTestDataBanner() {
  const { content, mode, setMode } = useTestDataBanner();

  return (
    <div className="test-data-banner is-global" role="note" aria-label="Test data controls">
      <div className="test-data-banner-lead">
        <span className="test-data-banner-tag">Test data</span>
        <span className="test-data-banner-note">
          {content?.note || 'Local sample data — no API. Pick a season phase to preview.'}
        </span>
      </div>
      <div className="test-data-banner-controls">
        <span className="test-data-field-label">Season phase</span>
        <div className="test-data-seg" role="tablist" aria-label="Season phase">
          {TEST_DATA_MODES.map((m) => (
            <button
              key={m.key}
              type="button"
              role="tab"
              aria-selected={mode === m.key}
              className={mode === m.key ? 'on' : ''}
              onClick={() => setMode(m.key)}
            >
              {m.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GlobalTestDataBanner;
